import ApiHttp from "./ApiHttp";
import utils from "./utils";

type LoanProps = {
  from_account_id: string;
  to_account_id: string;
  amount: string;
  payment_type: string;
  idempotencyKey: string;
  from_account_source?: string;
};

class LoanPayment {
  from_account_id;

  to_account_id;

  amount;

  payment_type;

  idempotencyKey;

  from_account_source: string;

  constructor(props: LoanProps) {
    this.from_account_id = props.from_account_id;
    this.to_account_id = props.to_account_id;
    this.amount = props.amount;
    this.payment_type =
      props.payment_type === "principal" ? props.payment_type : "default";
    this.idempotencyKey = props.idempotencyKey;
    this.from_account_source = props.from_account_source ?? "";
  }

  submit() {
    const endpoint =
      this.from_account_source === "external"
        ? "loan_payments/ach"
        : "internal_loan_payments/";

    return ApiHttp.fetch(
      endpoint,
      { method: "POST", headers: { "Idempotency-Key": this.idempotencyKey } },
      {
        amount: utils.dollarsToPennies(this.amount.replace(/[^\d.]/g, "")),
        from_account: this.from_account_id,
        to_account: this.to_account_id,
        payment_type: this.payment_type,
      },
    );
  }
}

export default LoanPayment;
